import React from 'react'
import { Config } from '@leverege/plugin'
import DefectImageEditor from './DefectImageEditor.jsx'

const opts = { 
  table : { embed : true, isRenderer : false },
  detail : { embed : true, isRenderer : false }
}

const editor = {
  name : 'defect.image',
  objectType : 'defect',
  create : ( opts ) => {
    const { usage, style, context, attribute, editable, canSet, variant, ...options } = opts
    return <DefectImageEditor {...opts}/>
  },
  getOptions : ( usage ) => { 
    return Config.get( 'AttributeValueEditor', usage, opts[usage] ) 
  },
}

const install = ( molten ) => {
  molten.addPlugin( 'AttributeValueEditor', editor )
}

export default {
  install
}
